import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: undefined, // optional Mã tự sinh
    duyet: // optional Thông tin duyệt
    {
        duoc_duyet: undefined, // required Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: undefined, // optional Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: undefined, // optional Mã người duyệt
    },
    hoat_dong: { // optional Thông tin hoạt động
        ngung_hoat_dong: null, // optional Cho biết đơn vị có đang ngừng hoạt động hay không. Mặc định là đang hoạt động
        thoi_diem_thay_doi_cuoi: null, // optional Thời điểm ngừng hoạt động/hoạt động trở lại (gần nhất)
    },
    loai_diem_den: undefined, // required, enum(international_travel, domestic_travel, hotel, tourist_villa, tourist_apartment, tourist_cruise, camping, motel, homestay, tourist_carriers, shopping, restaurant, tourist_area, tourist_attraction, entertainment) Loại điểm đến
    thong_tin_chung: // optional Thông tin chung
    {
        ten: undefined, // required Tên điểm đến
        anh: undefined, // optional Mã ảnh đại diện trên hệ thống survey
        giay_to: // optional Thông tin giấy tờ định danh điểm đến
        {
            so_giay_to: undefined, // optional Mã số thuế/Mã số doanh nghiệp
            noi_cap: undefined, // optional Nơi cấp
            ngay_cap: undefined, // optional Ngày cấp
            scan: undefined, // optional Danh sách mã ảnh scan
            dia_chi: undefined, // optional Địa chỉ trên đăng ký kinh doanh
        },

        dia_chi: // optional Thông tin địa chỉ
        {
            quoc_gia: undefined, // optional Quốc gia
            quoc_tich_id: undefined, // optional Mã quốc tịch
            tinh: undefined, // optional Tên tỉnh
            tinh_id: undefined, // optional Mã tỉnh
            xa: undefined, // optional Tên xa
            xa_id: undefined, // optional Mã xã
            dia_chi: undefined, // optional Địa chỉ giao dịch
            kinh_do: undefined, // optional Kinh độ
            vi_do: undefined, // optional Vĩ độ
        },

        nguoi_dai_dien: // optional Thông tin người đại diện
        {
            ho_ten: undefined, // optional Họ và tên
            chuc_vu: undefined, // optional Chức vụ
            ngay_sinh: undefined, // optional Ngày sinh
            so_giay_to: undefined, // optional Số CMT/ Căn cước/ Hộ chiếu
            gioi_tinh: undefined, // optional Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
            dia_chi: undefined, // optional Địa chỉ
            dien_thoai: undefined, // optional Điện thoại
            email: undefined, // optional Email
        },
        loai_hinh_uu_dai: undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
        gia_tri_uu_dai: undefined, // optional, min: 0 - Giá trị ưu đãi
        huong_dan_vien: // optional - Các thông tin cho hướng dẫn viên
        {
            uu_dai: // optional - Thông tin ưu đãi
            {
                loai_hinh_uu_dai: undefined, // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
                gia_tri_uu_dai: undefined, // optional, min: 0 - Giá trị ưu đãi
            }
        }
    },

    du_lieu_khai_bao: // optional Dữ liệu khai báo khi đăng ký điểm đến
    {
        user_account: undefined, // optional account của điểm đến
    },
    nguoi_tao_id: undefined, // required Mã người tạo
    thoi_diem_tao: undefined, // required Thời điểm tạo
    album: [ // optional Album ảnh của điểm đến
    {
        ngon_ngu: undefined, // required Ngôn ngữ hiển thị
        anh_id: undefined, // required Id của ảnh hiển thị
        tieu_de: undefined, // optional Tiêu đề của ảnh
    }],
    noi_dung_hien_thi:[  // optional Nội dung hiển thị
        {
            ngon_ngu: undefined, // required Ngôn ngữ hiển thị
            gioi_thieu: undefined, // required Giới thiệu thông tin
            anh_id: undefined, // optional Id của ảnh hiển thị
            noi_dung: undefined, // required Nội dung hiển thị
        }
    ],
    ngon_ngu: "vi",
    noiDungHienThiFilter: {
        gioi_thieu: undefined,
        anh_id: undefined,
        noi_dung: undefined,
    },
    listImageUrl: {
        anh_id: undefined,
        tieu_de: undefined,
        ngon_ngu: undefined,
        type: undefined
    },
    albumAnhFilter: {
        anh_id:undefined
    }
};

// validation form
model.validForm = {
    duyet: { //object, optional // Thông tin duyệt
        duoc_duyet: [], //boolean, optional // Cho biết điểm đến đã được duyệt hay chưa
        thoi_diem_duoc_duyet: [], //datetime, optional // Cho biết thời điểm điểm đến đã được duyệt
        nguoi_duyet_id: [], //IdRef, optional // Mã người duyệt
    },
    loai_diem_den: [], //string, optional // Loại điểm đến
    thong_tin_chung: { //object, optional // Thông tin chung
        ten: [], //string, optional // Tên điểm đến
        anh: [], //IdRef, optional // Mã ảnh đại diện
        huong_dan_vien: // optional - Các thông tin cho hướng dẫn viên
        {
            uu_dai: // optional - Thông tin ưu đãi
            {
                loai_hinh_uu_dai: [], // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
                gia_tri_uu_dai: [], // optional, min: 0 - Giá trị ưu đãi
            }
        },
        loai_hinh_uu_dai: [], // optional, enum(giam_gia_tien, giam_gia_phan_tram) - Loại hình ưu đãi
        gia_tri_uu_dai: [], // optional, min: 0 - Giá trị ưu đãi
    },
    "noiDungHienThiFilter.gioi_thieu":[],
    "noiDungHienThiFilter.noi_dung":[],
    "noiDungHienThiFilter.anh_id":[],
    du_lieu_khai_bao: [], //object, optional // Dữ liệu khai báo khi đăng ký điểm đến
    nguoi_tao_id: [], //IdRef, optional // Mã người tạo
    thoi_diem_tao: [], //datetime, optional // Thời điểm tạo
};


// dữ liệu mẫu các form khác
model.dataFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: null, //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: null, //string, optional // Nơi cấp
        ngay_cap: null, //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: null, //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: null, //string, optional // Quốc gia
        quoc_tich_id: null, //IdRef, optional // Mã quốc tịch
        tinh: null, //string, optional // Tên tỉnh
        tinh_id: null, //IdRef, optional // Mã tỉnh
        xa: null, //string, optional // Tên xa
        xa_id: null, //IdRef, optional // Mã xã
        dia_chi: null, //string, optional // Địa chỉ giao dịch
        kinh_do: null, //double, optional // Kinh độ
        vi_do: null, //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: null, //string, optional // Họ và tên
        chuc_vu: null, //string, optional // Chức vụ
        ngay_sinh: null, //datetime, optional // Ngày sinh
        so_giay_to: null, //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: null, //integer, optional // Giới tính
        dia_chi: null, //string, optional // Địa chỉ
        dien_thoai: null, //string, optional // Điện thoại
        email: null, //string, optional // Email
    },
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AlbumAnh: {
          limit: null,
          accept: ".jpg, .png, .jpeg, .mp4, .avi, .mov",
          dialogImageUrl: "",
          dialogVisible: false,
          fileList: [],
        },
        AnhThongTin: {
          limit: 1,
          accept: ".jpg, .png, .jpeg",
          dialogImageUrl: "",
          dialogVisible: false,
          fileList: []
        }
    },
};

// validation các form khác
model.validFormOther = {
    giay_to: { //object, optional // Thông tin giấy tờ định danh điểm đến
        so_giay_to: [], //string, optional // Mã số thuế/Mã số doanh nghiệp
        noi_cap: [], //string, optional // Nơi cấp
        ngay_cap: [], //datetime, optional // Ngày cấp
        scan: [], //array of IdRef, optional // Danh sách mã ảnh scan
        dia_chi: [], //string, optional // Địa chỉ trên đăng ký kinh doanh
    },
    dia_chi: { //object, optional // Thông tin địa chỉ
        quoc_gia: [], //string, optional // Quốc gia
        quoc_tich_id: [], //IdRef, optional // Mã quốc tịch
        tinh: [], //string, optional // Tên tỉnh
        tinh_id: [], //IdRef, optional // Mã tỉnh
        xa: [], //string, optional // Tên xa
        xa_id: [], //IdRef, optional // Mã xã
        dia_chi: [], //string, optional // Địa chỉ giao dịch
        kinh_do: [], //double, optional // Kinh độ
        vi_do: [], //double, optional // Vĩ độ
    },
    nguoi_dai_dien: { //object, optional // Thông tin người đại diện
        ho_ten: [], //string, optional // Họ và tên
        chuc_vu: [], //string, optional // Chức vụ
        ngay_sinh: [], //datetime, optional // Ngày sinh
        so_giay_to: [], //string, optional // Số CMT/ Căn cước/ Hộ chiếu
        gioi_tinh: [], //integer, optional // Giới tính
        dia_chi: [], //string, optional // Địa chỉ
        dien_thoai: [], //string, optional // Điện thoại
        email: [], //string, optional // Email
    }
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "thong_tin_chung.ten": "",
            loai_diem_den: "",
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ''
        },
        valid: {
            "thong_tin_chung.ten": [],
            loai_diem_den: [],
            'duyet.duoc_duyet': [],
            'du_lieu_khai_bao.user_account': []
        },
        operator: {
            "thong_tin_chung.ten": "$vn_text=", //:regex:, $vn_text=Viêt nam
            loai_diem_den: "",
            'duyet.duoc_duyet': '',
            'du_lieu_khai_bao.user_account': ':regex:'
        }
    }
};

export default model;
